import { Trans } from '@lingui/react'
import { isNil } from 'ramda'

import { useSelectCashAmountMutation } from '@twisto/api-graphql'
import type { CastedSubmitHandler } from '@twisto/components/atoms/form'
import {
  Headline,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { styleUtils } from '@twisto/styles'

import { useFlow } from '../../flow/flow.context'

import type { FormValues } from './select-cash-amount-step-form'
import { SelectCashAmountStepForm } from './select-cash-amount-step-form'

export const SelectCashAmountStep = () => {
  const { sessionId, flow } = useFlow<'SelectCashAmountStep'>()

  const [selectCashAmount, { loading }] = useSelectCashAmountMutation()
  const currentStepData = flow.currentStep

  if (isNil(currentStepData)) {
    return null
  }

  const handleSubmit: CastedSubmitHandler<FormValues> = ({ amount }) => {
    selectCashAmount({
      variables: {
        auth: {
          sessionId,
        },
        input: {
          amount,
        },
      },
    })
  }

  return (
    <>
      <Headline css={styleUtils.margin.bottom.xl}>
        <HeadlineTitle>
          <Trans id="flow.selectCashAmountStep.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans id="flow.selectCashAmountStep.subtitle" />
        </HeadlineSubtitle>
      </Headline>

      <SelectCashAmountStepForm
        cashOfferRange={currentStepData.offerRange}
        loading={loading}
        onSubmit={handleSubmit}
      />
    </>
  )
}
